import type { ListBuilderList } from '../../../types';
import { createVehicleColumns } from '../columns';

/**
 * Available vehicles list configuration
 * Shows vehicles that are active and not currently assigned to a route
 */
export const availableVehiclesList: ListBuilderList = {
	id: 'default-vehicles-available',
	name: 'Available',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		vehicleStatus: {
			defaultValue: [{ id: 'active', label: 'Active' }],
		},
		vehicleRouteStatus: {
			defaultValue: [{ id: 'available', label: 'Available' }],
		},
	},
	columns: createVehicleColumns(),
	defaultSortId: 'vehicle-name',
	sortOrder: 2,
};
